import React, { useEffect } from "react";

import { googleMapKey } from "../../variables/apikeys";
import {Card, CardHeader, CardTitle, CardBody, Col, Row, Button, FormGroup, Input, Label, Alert} from "reactstrap";
import { colors, opacities, borderWeights, getIcon, MODE_GRAB, MODE_MARKER, MODE_POLYGON, aryAlphabet, encodeArrayPoints } from "../../variables/maps";
import { object, reject } from "underscore";
//import { google } from "../../common/StaticMap";
import {
    Modal,
    ModalBody,
    ModalFooter,
} from "reactstrap";

import Request from "../../common/Request";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import {GetMessage} from '../../variables/message';

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//export const baseMapSize = {width:640, height: 480}
export const baseMapSize = {width:640, height: 365}

export default class MapViews extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            view_index: 0,
            modal_monochrome_map : false,
            confirm_map_url: false,
            modal_map_index: 0,
            googleMaps: {
                map: null,
                window: []
            },
            mounted :true,
            request_data: this.props.request_data,
            map_settings: {
                streetViewControl: false,
                rotateControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                center : {
                    lat: this.props.request_data? this.props.request_data.latitude : 35.68370098971363,
                    lng: this.props.request_data? this.props.request_data.longitude : 139.7004348630834
                },
                zoom: 18,
                gestureHandling: "greedy"
            },
            map_data : [...this.onParkingDrawData()],
            flagged_parkings : this.props.flagged_parkings? [...this.props.flagged_parkings]: [],
            mono_styles : [
                {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers:[{color:"#ffffff"}]
                },
                {
                    featureType: "water",
                    elementType: "geometry.stroke",
                    stylers:[{color:"#000000"}]
                },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry.fill",
                    stylers:[{color:"#ffffff"}]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.fill",
                    stylers:[{color:"#ffffff"}]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.stroke",
                    stylers:[{color:"#000000"}]
                },
                {
                    featureType: "poi",
                    elementType: "geometry.fill",
                    stylers:[{color:"#ffffff"}]
                },
                {
                    featureType: "road.highway",
                    stylers:[
                        {saturation: -100},
                        {lightness:50}
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers:[{visibility:"off"}]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "labels.icon",
                    stylers:[{visibility:"off"}]
                },
                {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers:[{color:"#000000"}]
                },
            ],
            error:[],
        }

        this.onLoad = this.onLoad.bind(this);
        this.loadMapView = this.loadMapView.bind(this);
        this.onchangeMemo = this.onchangeMemo.bind(this);
        this.drawDirections = this.drawDirections.bind(this);
        this.onChangeHandle = this.onChangeHandle.bind(this);
        this.onClickHandle = this.onClickHandle.bind(this);
        this.onClickMapHandle = this.onClickMapHandle.bind(this);
        this.controller = this.controller.bind(this);
        this.parkingDetail = this.parkingDetail.bind(this);
        this.save = this.save.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.addSvgPinMarker = this.addSvgPinMarker.bind(this);
        this.addDistinateMarker = this.addDistinateMarker.bind(this);
        this.addFlaggedParkingMarker = this.addFlaggedParkingMarker.bind(this);
        this.addMakerImage = this.addMakerImage.bind(this);
        this.addMemo = this.addMemo.bind(this);
        this.addPolygon = this.addPolygon.bind(this);
        this.deleteMemo = this.deleteMemo.bind(this);
        this.convert_object_marker = this.convert_object_marker.bind(this);
        this.convert_uri_marker = this.convert_uri_marker.bind(this);
        this.convert_object_direction = this.convert_object_direction.bind(this);
        this.convert_uri_direction = this.convert_uri_direction.bind(this);
        this.convert_object_polygon = this.convert_object_polygon.bind(this);
        this.convert_uri_polygon = this.convert_uri_polygon.bind(this);
        this.convert_object_memo = this.convert_object_memo.bind(this);
        this.convert_uri_memo = this.convert_uri_memo.bind(this);
        this.convert_map_param = this.convert_map_param.bind(this);
        this.onchangeMapIndex = this.onchangeMapIndex.bind(this);
    }

    onParkingDrawData () {
        if (this.props.parking_objects) {
            let data_with_options = this.props.parking_objects.map((obj, index)=>{
                let coordinates = obj.map(parking=>{
                    return({
                        data: parking,
                        lat: parking.latitude,
                        lng: parking.longitude
                    })
                })

                return ({
                    isload: false,
                    edit_mode: MODE_POLYGON,
                    map_settings: {},
                    objects : {
//                        element_id: "MapDiv-"+(index + 1),
                        element_id: "MapDiv",
                        map: null,
                        window: [],
                        window_instance: [],
                        distinates_markers : [], // 目的地アイコン
                        direction_renders : [],
                        direction_services: [],
                        direction_waypoints: [],
                        markers : [],
                        polygons : [],
                        memo_marks : []
                    },
                    settings : {
                        polygonIndex: 0
                    },
                    // 緯度経度情報
                    coordinates : { 
                        // 現場
                        start : {
                            lat: this.props.request_data? this.props.request_data.latitude : 35.68370098971363,
                            lng: this.props.request_data? this.props.request_data.longitude : 139.7004348630834
                                },
                        distinates: [...coordinates]
                    },
                    // 経路描画用設定
                    map_drawer_options : {
                        draggable: true,
                        preserveViewport: true,
                        markerOptions: true,
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor:colors[1].value,
                            strokeOpacity:opacities[1].value,
                            strokeWeight:borderWeights[2].value
                        },
                    },
                    direction_stroke_options: [
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                            polylineOptions: {
                                strokeColor:colors[0].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[2].value
                            }
                        },
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                                polylineOptions: {
                                strokeColor:colors[1].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[2].value
                            }
                        },
                        {
                            draggable: true,
                            preserveViewport: true,
                            markerOptions: true,
                            suppressMarkers: true,
                                polylineOptions: {
                                strokeColor:colors[2].value,
                                strokeOpacity:opacities[1].value,
                                strokeWeight:borderWeights[2].value
                            }
                        },
                    ],
                    // 図形描画用設定
                    polygon_drawer_options : {
                        draggable: true,
                        editable: true,
                        strokeColor:"#5a03fc",
                        strokeOpacity:0.8,
                        strokeWeight:2,
//                        fillColor:"#03fc6f",
                        fillColor:"#5a03fc",
                        fillOpacity:0.5,
                    },
                    child_map_options : {
                        draggable: false,
                        preserveViewport: true,
                        markerOptions: true,
                        polylineOptions: {
                            strokeColor:colors[1].value,
                            strokeOpacity:opacities[1].value,
                            strokeWeight:borderWeights[2].value
                        },
                    }
                });
            })
            return data_with_options
        }
        return null;
    }

    componentDidMount() {
        Request.setProgress(20,"地図読み込み中")
        let s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=drawing&v=weekly&channel=2`;
        let x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
        window.setTimeout(()=>{Request.setProgress(80,"地図読み込み中")},500)

        s.addEventListener('load', () => {
            this.onLoad();
            //onLoadMapParkingDetail();
            window.setTimeout(()=>{Request.setProgress(0,"地図読み込み中")},1000)
        });
    }
    componentDidUpdate (prevProps) {
        let isUpdate = false;

        if ( prevProps.parking_objects != this.props.parking_objects && this.props.parking_objects != null) {
            isUpdate = true;
        }

        if ( isUpdate ) {
        }
    }
    onLoad () {
        let {
            map_data,
            map_settings
        } = this.state

        let mapId = document.getElementById(map_data[0].objects.element_id);
        let map = new window.google.maps.Map(mapId, map_settings);
        let infoWindow = new window.google.maps.InfoWindow();
        this.handleLocationError(false, infoWindow, map.getCenter());

        window.google.maps.event.addListener(map,"click",(e)=>{this.onClickMapHandle( e )})

        this.setState({ 
            googleMaps : {
                ...this.state.googleMaps,
                map : map
            },
        },()=>{
            this.loadMapView(0);
        })
    }
    loadMapView (index) {
        let icon = getIcon("site");
        let mapData = this.state.map_data;
        let data = this.state.map_data[index];
//        let map = data.objects.map;
        let map = this.state.googleMaps.map;
        let markers = [...data.objects.markers];
        let marker = new window.google.maps.Marker({
            position: data.coordinates.start,
            draggable: false,
            map,
            icon: new window.google.maps.MarkerImage(
                icon.iconLinkUrl,
                new window.google.maps.Size(icon.size.width, icon.size.height),
                new window.google.maps.Point(0, 0),
                new window.google.maps.Point(icon.size.width/2, icon.size.height*1.2)
            )
        })
        markers.push(marker)
        markers = markers.concat(this.addFlaggedParkingMarker(index))

        // 経路の描画
        let direction = this.drawDirections(data, index, markers);

        mapData[index] = {
            ...data,
            isload: true,
            map_settings: this.state.map_settings,
            direction_stroke_options: direction.map(d=>{return d.draw_options}),
            objects : {
                ...data.objects,
                markers: markers,
                direction_renders: direction.map(d=>{return d.render}),
                direction_services: direction.map(d=>{return d.service}),
                distinates_markers: direction.map(d=>{return d.markers}),
            }
        }

        this.setState({map_data: mapData},()=>{
            let {map_settings} = this.state.map_data[this.state.view_index];
            this.state.googleMaps.map.setOptions(map_settings);
        })
    }

    addMarker (index, latLng, labels, options={}, marker=null) {
//        let { map } = this.state.map_data[index].objects;
        let { map } = this.state.googleMaps;

        let defaultIconOptions = {
            scale: 8,
            labelOrigin: new window.google.maps.Point(0, -2.5),
            fillColor: (options.fillColor)? options.fillColor: "#FF0000",//塗り潰し色
            fillOpacity: (options.fillOpacity)? options.fillOpacity: 0.8,//塗り潰し透過率
            strokeColor: (options.strokeColor)? options.strokeColor: "#FF0000",//枠の色
            strokeWeight: (options.strokeWeight)? options.strokeWeight: 1.0, //枠の透過率
        }

        if ( options.pathString ) {
            switch (options.pathString) {
                case "circle":defaultIconOptions.path = window.google.maps.SymbolPath.CIRCLE; break;
                case "arrowUp-1":defaultIconOptions.path = window.google.maps.SymbolPath.BACKWARD_OPEN_ARROW; break;
                case "arrowDw-1":defaultIconOptions.path = window.google.maps.SymbolPath.FORWARD_OPEN_ARROW; break;
                case "arrowUp-2":defaultIconOptions.path = window.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW; break;
                case "arrowDw-2":defaultIconOptions.path = window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW; break;
            }
        }

        if (marker) {
            marker.setOptions({
                position: new window.google.maps.LatLng(latLng),
                draggable: true,
                map,
                icon:defaultIconOptions,
                label: {
                    text: labels.text,
                    color: labels.color? labels.color: "#FFFFFF",
                    fontSize: labels.fontSize? labels.fontSize: "20px"
                }
            })
        }
        else {
            marker = new window.google.maps.Marker({
                position: new window.google.maps.LatLng(latLng),
                draggable: true,
                map,
                icon:defaultIconOptions,
                label: {
                    text: labels.text,
                    color: labels.color? labels.color: "#FFFFFF",
                    fontSize: labels.fontSize? labels.fontSize: "20px"
                }
            })
        }
        return marker;
    }

    addSvgPinMarker (index, latLng, labelText, color="#8B0000") {
//        const {map} = this.state.map_data[index].objects;
        const {map} = this.state.googleMaps;

        let path = "M82 464 c-51 -26 -77 -70 -77 -130 0 -43 7 -62 52 -136 29 -47 60 -105 68 -129 9 -24 18 -51 21 -59 3 -9 13 8 23 41 10 32 42 95 70 142 61 99 72 147 46 201 -35 73 -131 106 -203 70z"
        let size = { width: 30, height: 48}
        const svg = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${size.width}pt" height="${size.height}pt" viewBox="0 0 ${size.width} ${size.height}" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,${size.height}.000000) scale(0.100000,-0.100000)" fill="${color}" stroke="none">
        <path d="${path}" />
        </g></svg>`
        const iconSvgUrl = {
            url: `data:image/svg+xml,${encodeURIComponent(svg)}`, 
            scaledSize: new window.google.maps.Size(size.width, size.height), 
            labelOrigin: new window.google.maps.Point(15, 15),
            fillColor: color
        }

//        console.log(iconSvgUrl)
        let marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(latLng),
            draggable: true,
            map,
            icon: iconSvgUrl,
            label: {
                text: labelText,
                color: "#FFFFFF",
                fontSize: "20px"
            }
        })
        return marker
    }


    addDistinateMarker (index, subIndex, latLng, labels, options={}) {
        let {
            distinates_markers
        } = this.state.map_data[index].objects;
        let marker;

        if (distinates_markers[subIndex]) {
            marker = distinates_markers[subIndex]
            marker.setOptions({
                ...marker.getOptions(),
                label: {
                    text: labels.text,
                    color: labels.color? labels.color: "#FFFFFF",
                    fontSize: labels.fontSize? labels.fontSize: "20px"
                }
            })
        }
        else {
            let cnt = index * 3 + subIndex

            marker = this.addSvgPinMarker(index, latLng, aryAlphabet[cnt], options.fillColor)
        }

        return marker;
    }

    addFlaggedParkingMarker (index) {

        let data = this.state.map_data[index]
//        let map = data.objects.map;
        let map = this.state.googleMaps.map;
        let distance = 0
        data.coordinates.distinates.forEach((park)=>{
            distance = (parseInt(park.data.site_distance_meter)<distance)? distance: parseInt(park.data.site_distance_meter)
        })
        let viewFlaggedParking = this.state.flagged_parkings.filter((p)=>distance>parseInt(p.site_distance_meter))
        let markers = []

        // 経路図表示設定の駐車場を地図にマーカ表示する
        if (viewFlaggedParking) {
            viewFlaggedParking.forEach((p,n)=>{
                let flagsIcon = getIcon("png-"+p.request_parking_status)
                let mark = new window.google.maps.Marker({
                    position: {lat: p.latitude, lng: p.longitude},
                    draggable: false,
                    map,
                    icon: new window.google.maps.MarkerImage(
                        flagsIcon.iconLinkUrl,
                        new window.google.maps.Size(flagsIcon.size.width, flagsIcon.size.height),
                        new window.google.maps.Point(0, 0), // element内の表示位置
                        new window.google.maps.Point(flagsIcon.size.width / 2, flagsIcon.size.height * 1.2)  // 指定した緯度経度を起点としたマップ上の表示位置
                    )
                })
                markers.push(mark)
            })
        }
        return markers;
    }

    addMakerImage (index, latLng, imageId) {
        //let { map } = this.state.map_data[index].object;
        let { map }=this.state.googleMaps;

        let icon = getIcon(imageId);

        let marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(latLng),
            draggable: true,
            map,
            icon: new window.google.maps.MarkerImage(
                icon.iconLinkUrl,
                new window.google.maps.Size(icon.size.width, icon.size.height),
                new window.google.maps.Point(0, 0), // element内の表示位置
                new window.google.maps.Point(icon.size.width / 2, icon.size.height)  // 指定した緯度経度を起点としたマップ上の表示位置
            )
        })
        return marker;
    }

    addMemo (index) {

//        const {map} = this.state.map_data[index].objects;
        const {map} = this.state.googleMaps;
        let map_data = this.state.map_data
        let memo_marks =  [...this.state.map_data[index].objects.memo_marks];
        let arrayWindow = [...this.state.map_data[index].objects.window];
        let arrayInstance = [...this.state.map_data[index].objects.window_instance]

        if (arrayWindow.length >= 3) {
            return;
        }

        let newWindow = new window.google.maps.InfoWindow();
        const center = {lat:map.getCenter().lat(), lng:map.getCenter().lng()};

        let nextIndex = arrayWindow.length
        let num = nextIndex + 1
//        let marker = this.addMarker(index, center, {text:num.toString()}, {pathString:"arrowUp-2"})
        let marker = this.addSvgPinMarker(index, center, num.toString())
        newWindow.setContent("")
        newWindow.open({
            anchor: marker,
            map,
            shouldFocus: false
        })


        arrayInstance.push( newWindow.addListener("closeclick",()=>this.deleteMemo(index, nextIndex)) )

        memo_marks.push(marker)
        arrayWindow.push(newWindow)

        map_data[index].objects.memo_marks = memo_marks
        map_data[index].objects.window = arrayWindow
        map_data[index].objects.window_instance = arrayInstance

        this.setState({map_data: map_data})
    }

    deleteMemo(index, mIndex){

        let map_data = this.state.map_data
        let {
            window:windows,
            memo_marks,
            window_instance
        } = map_data[index].objects

        let tmpError = this.state.error ? this.state.error: [];
        if(tmpError[`P${index}`] && Object.keys(tmpError[`P${index}`]).length){
            if(tmpError[`P${index}`][`M${mIndex}`]){
                delete(tmpError[`P${index}`][`M${mIndex}`]);
            }
            if(!Object.keys(tmpError[`P${index}`]).length){
                delete(tmpError[`P${index}`]);
            }else{
                switch(mIndex){
                    case 0 :
                        let key = Object.keys(tmpError[`P${index}`]);
                        key.forEach((k)=>{
                            if(k == "M1"){
                                tmpError[`P${index}`]["M0"] = tmpError[`P${index}`][k];
                            } else if (k == "M2"){
                                tmpError[`P${index}`]["M1"] = tmpError[`P${index}`][k];
                                delete(tmpError[`P${index}`][k]);
                            }
                        });
                    break;
                    case 1 :
                        tmpError[`P${index}`]["M1"] = tmpError[`P${index}`]["M2"];
                        delete(tmpError[`P${index}`]["M2"]);
                        break;
                }    
            }

        }

        windows[mIndex].close()
        memo_marks[mIndex].setMap(null)

        windows = windows.filter((wn,i)=>i!=mIndex)
        window_instance = window_instance.filter((f,i)=>i!=mIndex)

        windows.map((win, i)=>{
            window_instance[i].remove()
            window_instance[i] = win.addListener("closeclick",()=>this.deleteMemo(index,i))
        })

        let renew_markers = memo_marks.filter((mrk, i)=>i!=mIndex)

        let markers = renew_markers.map((marker, i)=>{
            let label = marker.getLabel()
            let index = i + 1
            label.text = index.toString()
            marker.setLabel(label)
            return marker
        })

        map_data[index] = {
            ...map_data[index],
            objects: {
                ...map_data[index].objects,
                window: windows,
                window_instance: window_instance,
                memo_marks: markers
            }
        }
        this.setState({map_data: map_data})
    }

    // メモの内容を編集
    onchangeMemo (e, index, mIndex) {
        // console.log(index);
        // console.log(mIndex);
        // console.log(this.state.error);
        let content = e.target.value
        let map_data = this.state.map_data
        let tmpError = this.state.error ? this.state.error: [];
        tmpError[`P${index}`] = tmpError[`P${index}`] ? tmpError[`P${index}`] : [];
        if(content.length > 60){
            tmpError[`P${index}`][`M${mIndex}`] = GetMessage("2032");
        }else{
            if(tmpError[`P${index}`][`M${mIndex}`]){
                delete(tmpError[`P${index}`][`M${mIndex}`]);
            }
            if(!Object.keys(tmpError[`P${index}`]).length){
                delete(tmpError[`P${index}`]);
            }
        }

        map_data[index].objects.window[mIndex].setContent(content)

        this.setState({map_data:map_data,error:tmpError})
    }

    // 図形追加処理
    addPolygon ( e, index ) {
        let map = this.state.googleMaps.map;
        let {polygonIndex} = this.state.map_data[index].settings
        let {polygons} = this.state.map_data[index].objects
        const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };

        // 追加処理
        if ( polygons.length <= polygonIndex ) {
            // Plygonオブジェクトの生成
            polygons.push(
                new window.google.maps.Polygon({
                    ...this.state.map_data[index].polygon_drawer_options,
                    paths: [latLng]
                })
            );
            polygons[polygonIndex].setMap( map )
        } else {
            var coords = []
            const paths = polygons[polygonIndex].getPath()
            for ( var i = 0; i < paths.getLength(); i ++ ) {
                const coord = paths.getAt(i);
                coords.push({ lat: coord.lat(), lng: coord.lng() })
            }
            coords.push(latLng);
            polygons[polygonIndex].setPath(coords);
        }
    }

    // 経路の描画
    drawDirections ( param, index, markers=[] ) {
        let {map} = this.state.googleMaps
        let {
            map_drawer_options,
            direction_stroke_options,
            objects,
            isload,
        } = this.state.map_data[index];

        let directionStrokeOptions = [...direction_stroke_options]
        let directionService = new window.google.maps.DirectionsService();
        var bounds = new window.google.maps.LatLngBounds();

        const drawDirectionsLiner = param.coordinates.distinates.map((coord, subIndex) => {
//            const promise = new Promise ( async(resolve, reject) => {
                const start = new window.google.maps.LatLng({
                    lat: param.coordinates.start.lat,
                    lng: param.coordinates.start.lng
                });
                const end = new window.google.maps.LatLng(coord.lat, coord.lng);
                const request = {
                    origin: start, 
                    destination: end,
                    travelMode: "WALKING"
                };

//                let directionService;
                let directionRender;
                let marks;
                let options = (directionStrokeOptions[subIndex])? directionStrokeOptions[subIndex] : map_drawer_options
                let num = subIndex + 1
                let strokeColor = options.polylineOptions.strokeColor

                marks = this.addDistinateMarker(
                    index, 
                    subIndex,
                    {lat: coord.lat, lng:coord.lng}, 
                    {text: num.toString()},
                    {fillColor: strokeColor, strokeColor: strokeColor}
                )

                bounds.extend (marks.position);

                const route = (directionService) => {
                    directionService.route(request, function(result, status) {
                        if (status === "OK") {
                            directionRender.setDirections(result); 
                        } else {
                            alert("取得できませんでした：" + status);
                        }
                    });
                }

                if ( objects.direction_renders.length > subIndex ) 
                {
                    directionRender = objects.direction_renders[subIndex];
                    const waypoints = objects.waypoints.length>0?objects.waypoints: [];
                    request.waypoints = waypoints;

                    directionRender.setOptions(options);
                    directionRender.setMap(map);
                    route(directionService)
                }
                else {

                    directionRender = new window.google.maps.DirectionsRenderer(options);
                    directionRender.setMap(map);

                    route(directionService)

                    window.google.maps.event.addListener(marks,"dragend",function(e){
                        let location = {
                            lat : marks.getPosition().lat(e),
                            lng : marks.getPosition().lng(e)
                        }
                        request.destination = new window.google.maps.LatLng(location);
                        directionService.route(request, function(result, status) {
                            if (status === "OK") {
                                directionRender.setDirections(result); 
                            } else {
                                alert("取得できませんでした：" + status);
                            }
                        });
                    })

                }
                return {render: directionRender, service: directionService, markers: marks, draw_options: options};
           });
           if (!isload){
                markers.forEach((m)=>{
                    bounds.extend(m.position)
                });
                map.fitBounds (bounds);
           }
        return drawDirectionsLiner;
    }

    handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: The Geolocation service failed."
                : "Error: Your browser doesn't support geolocation."
        );
//        infoWindow.open();
    }
    controller (setting, index) {
        let listSelectedColor = [...colors];
        let listSelectWeight = [...borderWeights];
        let listSelectOpacity = [...opacities];
        let {
            edit_mode, 
            map_drawer_options,
            direction_stroke_options : direcionStrokeOptions
        } = setting

//        console.log(setting)

        let {
            window,
            direction_renders
        }=this.state.map_data[index].objects

        return (<>
            <div className="setting-map">
                <div className="setting-map__item">
                    <h4 className="title">経路の線の編集</h4>
                    {direction_renders.map((direction, n)=>{
                        let strokeOption = (direcionStrokeOptions[n])? direcionStrokeOptions[n] : map_drawer_options
                        let num = index * 3 + n

                        return (
                            <div className="group-box group-box-attr">
                            <Row>
                                <Col style={{width:"1em",fontSize:"2em"}}>
                                    {n==0?(<>{aryAlphabet[num]}</>):(<>
                                        {n==1?(<>{aryAlphabet[num]}</>):(<>
                                            {n==2&&(<>{aryAlphabet[num]}</>)}
                                        </>)}
                                    </>)}
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label for="color">色</Label>
                                        <div className="select-box">
                                            <Input
                                                id="color"
                                                name="color"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeColor}
                                                value={strokeOption.polylineOptions.strokeColor}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectedColor.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label for="weight">太さ</Label>
                                        <div className="select-box">
                                            <Input
                                                id="weight"
                                                name="weight"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeWeight}
                                                value={strokeOption.polylineOptions.strokeWeight}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectWeight.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label for="opacity">透明度</Label>
                                        <div className="select-box">
                                            <Input
                                                id="opacity"
                                                name="opacity"
                                                type="select"
                                                defaultValue={strokeOption.polylineOptions.strokeOpacity}
                                                value={strokeOption.polylineOptions.strokeOpacity}
                                                onChange={(e) => this.onChangeHandle("StrokeAttr", e, index, n)}
                                            >
                                                {listSelectOpacity.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>                        )
                    })}
                </div>
                <div className="setting-map__item">
                    <h4 className="title">図形の描画</h4>
                    <div className="group-box">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("AddPolygon",index)}
                            disabled={edit_mode != MODE_POLYGON}
                        >
                            図形追加
                        </Button>
                        &emsp;
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("RollbackPolygon",index)}
                        >
                            一つ戻す
                        </Button>
                        &emsp;
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("ResetPolygon",index)}
                        >
                            リセット
                        </Button>
                    </div>
                </div>

                {/* メモ欄の追加 */}
                <div className="setting-map__item">
                    <h4 className="title">メモ欄の追加</h4>
                    <div className="group-box mb-3">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("AddMemo",index)}
                        >
                            メモ追加
                        </Button>
                    </div>
                    <div className="group-memo">
                    {window.map( (infoWindow, mIndex) => {
                            return (
                                <>
                                <FormGroup key={index+"-"+mIndex}>
                                    <Label for={`memo-${index}-${mIndex}`}>
                                        メモ{mIndex + 1}
                                    </Label>

                                    <Input
                                        id={`memo-${index}_${mIndex}`}
                                        name={`memo-${index}_${mIndex}`}
                                        placeholder="メモを入力してください"
                                        value={infoWindow.getContent()}
                                        onChange={(e) => this.onchangeMemo(e, index, mIndex)}
                                    />
                                    <div className="delete" onClick={() => this.deleteMemo(index,mIndex)}>
                                        <img src={require("assets/img/icon-dust.jpeg")} alt=""/>
                                    </div>
                                </FormGroup>
                                {this.state.error[`P${index}`] && this.state.error[`P${index}`][`M${mIndex}`] && <div style={{color:"red"}}>{this.state.error[`P${index}`][`M${mIndex}`]}</div>}
                                </>
                            )
                        }
                    )}
                    </div>
                </div>

                <div className="setting-map__item">
                    <div className="group-box group-box-grid">
                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("Preview",index)}
                        >
                            経路図プレビュー
                        </Button>

                        <Button
                            color="primary"
                            onClick={() => this.onClickHandle("GetUrl",index)}
                        >
                            URL取得
                        </Button>
                    </div>
                    {/*<Alert color="info" isOpen={isCopied} >
                        Copied!
                    </Alert>*/}
                </div>
            </div>
    </>)
    }
    onClickHandle (target, index) {
        let {
            objects,
            settings
        }=this.state.map_data[index]
        switch (target) {
            case "AddPolygon":{
                let {polygonIndex} = settings
                let len = objects.polygons.length
                if ((polygonIndex+1) == len) {
                    let map_data = this.state.map_data
                    let mapData = {
                        ...this.state.map_data[index],
                        settings: {
                            ...settings,
                            polygonIndex : polygonIndex+1
                        }
                    }
                    map_data[index] = {...mapData}

                    this.setState({ map_data : map_data });
                }
            }break
            case "ResetPolygon":{
                if ( objects.polygons.length > 0 ) {
                    objects.polygons.map((polygon, n)=>{
                        polygon.setMap(null)
                    })
                    let map_data = this.state.map_data
                    let mapData = {
                        ...this.state.map_data[index],
                        settings: {
                            ...settings,
                            polygonIndex : 0
                        },
                        objects: {
                            ...this.state.map_data[index].objects,
                            polygons:[]
                        }
                    }
                    map_data[index] = {...mapData}
                }
            }break
            case "RollbackPolygon": {
                if ( objects.polygons.length > 0 ) {
                    let map_data = this.state.map_data
                    let editIndex = objects.polygons.length - 1;
                    let pathsArray = objects.polygons[editIndex].getPath();

                    if (pathsArray.getLength()==1) {

                        objects.polygons[editIndex].setMap(null)
                        objects.polygons.pop()
                    }
                    else {
                        pathsArray.pop()
                        objects.polygons[editIndex].setPath(pathsArray)
                    }
                    map_data[index].objects = objects

                    // インデックス初期化
                    if(objects.polygons.length === 0){
                        map_data[index].settings.polygonIndex = 0
                    }
                    this.setState({map_data: map_data})
                }
            }break;
            case "AddMemo":{
                this.addMemo(index)
            }break
            case "RemoveMemo":{

            }break
            case "Preview": {
                this.setState({
                    modal_monochrome_map: true,
                    modal_map_index: index
                })
            }break;
            case "GetUrl": {
                this.setState({
                    confirm_map_url: true
                })
            }break;
        }
    }
    onChangeHandle (target, e, index, subIndex=0) {
        let {
            map_data
        } = this.state

        let isReload = false // 地図再読み込みフラグ

        switch (target) {
            case "ShapeType":{
                map_data[parseInt(index)] = {
                    ...this.state.map_data[parseInt(index)],
                    edit_mode : parseInt(e.target.value)
                }
            }break;
            case "StrokeAttr":{
                let attr = "";
                isReload = true

                let {
                    direction_stroke_options
                }=map_data[parseInt(index)]

                switch (e.target.name) {
                    case "color":{
                        attr = "strokeColor";
                    }break;
                    case "weight":{
                        attr = "strokeWeight";
                    }break;
                    case "opacity":{
                        attr = "strokeOpacity";
                    }break;
                }

                if (direction_stroke_options[subIndex]) {
                    direction_stroke_options[subIndex] = {
                        ...direction_stroke_options[subIndex],
                        polylineOptions : {
                            ...direction_stroke_options[subIndex].polylineOptions,
                            [attr] : e.target.value
                        }
                    }
                }

                map_data[parseInt(index)] = {
                    ...this.state.map_data[parseInt(index)],
                    direction_stroke_options: direction_stroke_options
/*                    
                    map_drawer_options : {
                        ...this.state.map_data[parseInt(index)].map_drawer_options,
                        polylineOptions: {
                            ...this.state.map_data[parseInt(index)].map_drawer_options.polylineOptions,
                            [attr] : e.target.value
                        }
                    }
*/
                }
            }break;
        }

        this.setState({
            map_data : map_data
        },()=>{
            if ( !isReload ) return;
            this.state.map_data.forEach((data, n)=>{
                if (index == n){
                    let {direction_renders} = data.objects
//                    console.log(map_data);
                    direction_renders.map((render,subIndex)=>{
//                        console.log(data);
                        render.setOptions(data.direction_stroke_options[subIndex])
//                        render.setMap(data.objects.map)
                        render.setMap(this.state.googleMaps.map)
                    })
                    
                } 
            })
        });
    }
    save () {
        if(this.state.error.P0 ||
           this.state.error.P1 || 
           this.state.error.P2 ||
           this.state.error.P3 ||
           this.state.error.P4 ){
            alert(GetMessage("2401"));
            return ;
        }


        let unloadId = ()=> {
            let array_id = []
            this.state.map_data.forEach((map, index)=>{
                if (map.isload===false) {
                    array_id.push(index)
                }
            })
            return array_id;
        }

        let id = unloadId();
//        console.log(id);

        if ( id.length>0 ) {
            this.onchangeMapIndex(id[0]);
            return;
        }

        if (this.props.callbackSaved) {
            let destinates = []
            let objects = this.state.map_data.map((md, index)=>{
                let directions = this.convert_object_direction(index)
                md.coordinates.distinates.map((item, n)=>{
                    let {direction} = directions[n]
                    directions[n].request_parking_ulid = item.data.request_parking_ulid
                    destinates.push({
                        ...direction,
                        request_parking_ulid: item.data.request_parking_ulid,
                    })
                })
                return {
                    "monochrome_map_url":this.staticmapUrl(index),
                    "objects": {
                        base_map : this.convert_map_object(index),
                        markers : this.convert_object_marker(index),
                        directions : directions,
                        polygons : this.convert_object_polygon(index),
                        memos: this.convert_object_memo(index), 
                    },
                }
            })

            this.props.callbackSaved(objects, destinates)
        }
    }

    convert_map_object(index) {
        let {map_settings} = this.state.map_data[index]

        return {
            size: {
                width: baseMapSize.width,
                height: baseMapSize.height
            },
            scale: "1",
            language: "ja",
            center: {
                lat: map_settings.center.lat,
                lng: map_settings.center.lng
            },
            zoom : map_settings.zoom,
            style:[
                {
                    feature:"water",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"water",
                    element:"geometry.stroke",
                    color:"#000000"
                },
                {
                    feature:"landscape.natural",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"landscape.man_made",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"landscape.man_made",
                    element:"geometry.stroke",
                    color:"#000000"
                },
                {
                    feature:"poi",
                    element:"geometry.fill",
                    color:"#ffffff"
                },
                {
                    feature:"road.highway",
                    saturation:"-100%",
                    lightness:"50%"
                },
                {
                    feature:"poi",
                    element:"labels",
                    visibility:"off"
                },
                {
                    feature:"landscape.man_made",
                    element:"labels.icon",
                    visibility:"off"
                },
                {
                    feature:"road",
                    element:"geometry.stroke",
                    color:"#000000"
                },
           ]
        }
    }

    convert_map_param(index, arrayflag=true) {
//        let baseMap = this.state.map_data[index].objects.map
//        if (baseMap == null) return 
        if (this.state.googleMaps.map == null) {
            return
        }

        let zoom;
        let center;
        if ( this.state.view_index == index ) {
            zoom = this.state.googleMaps.map.getZoom();
            center = {
                lat : this.state.googleMaps.map.getCenter().lat(),
                lng : this.state.googleMaps.map.getCenter().lng()
            }
        }
        else {
            center = this.state.map_data[index].map_settings.center
            zoom = this.state.map_data[index].map_settings.zoom
        }


        let arrayUrl = []
        arrayUrl.push("size="+baseMapSize.width + "x" + baseMapSize.height)
        arrayUrl.push("scale=1&language=ja")
        arrayUrl.push("center="+center.lat+","+center.lng)
        arrayUrl.push("zoom="+zoom)
        arrayUrl.push("style=feature:water%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:water%7Celement:geometry.stroke%7Ccolor:0x000000&style=feature:landscape.natural%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:landscape.man_made%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:landscape.man_made%7Celement:geometry.stroke%7Ccolor:0x000000&style=feature:poi%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.highway%7Csaturation:-100%7Clightness:50&style=feature:poi%7Celement:labels%7Cvisibility:off&style=feature:landscape.man_made%7Celement:labels.icon%7Cvisibility:off&style=feature:road%7Celement:geometry.stroke%7Ccolor:0x000000")
        return (arrayflag)? arrayUrl: "&" + arrayUrl.join("&")
    }

    convert_object_marker (index) {
        let {
            markers
        } = this.state.map_data[index].objects

        let rtnObject = []

        if (markers.length==0) return "" 

        markers.forEach((marker)=>{
            rtnObject.push({
                url: marker.getIcon().url,
                lat: marker.getPosition().lat(),
                lng: marker.getPosition().lng(),
            })
        })
        return rtnObject
    }
    convert_uri_marker (index, arrayflag = true) { 
        let {
            markers
        } = this.state.map_data[index].objects

        let rtnObject = []

        if (markers.length==0) return "" 

        markers.forEach((marker)=>{
            rtnObject.push(
                "markers=icon:"+marker.getIcon().url
                +"|"+marker.getPosition().lat()
                +","+marker.getPosition().lng()
            )
        })

//        console.log(markers, rtnObject)

        return (arrayflag)? rtnObject : "&" + rtnObject.join("&")
    }

    convert_object_direction (index) {
        let {
            objects,
            map_drawer_options: options,
            direction_stroke_options
        }=this.state.map_data[index]

        let {
            distinates_markers,
            direction_renders,
        } = objects

        let rtnObject = []

        if (direction_renders.length==0) return ""

        direction_renders.forEach((render, n)=>{
            let {
                strokeWeight,
                strokeColor,
                strokeOpacity
            } = direction_stroke_options[n].polylineOptions

            let marker = distinates_markers[n]
            let color = marker.getIcon().fillColor
            let text =  marker.getLabel().text
            const result = render.getDirections()
            let waypoints = []

            result.routes[0].legs[0].steps.forEach((step) => {
                step.path.forEach((point) => {
                    waypoints.push({ Lat: point.lat(), Lng: point.lng() });
                });
            });
            rtnObject.push({
                direction : {
                    color : strokeColor,
                    weight : strokeWeight,
                    opacity : strokeOpacity,
                    points : [...waypoints] ,
                    markers : {
                        text: text,
                        color : color, 
                        lat: marker.getPosition().lat(),
                        lng: marker.getPosition().lng(),
                    }
                }
            })
        })


        return rtnObject       
    }

    convert_uri_direction (index, arrayflag=true) {

        let {
            objects,
            map_drawer_options: options,
            direction_stroke_options
        }=this.state.map_data[index]
        let {
            distinates_markers,
            direction_renders,
        } = objects

        let rtnArray = []

        if (direction_renders.length==0) return ""

        distinates_markers.forEach((marker)=>{
//            console.log(marker)
            if ( marker && marker.getIcon() ) {
                let color = marker.getIcon().fillColor
                let text =  marker.getLabel().text
//                console.log(marker.getIcon(), color, text)

                rtnArray.push(
                    "markers=color:"+color.replace("#", "0x")
                    +"|label:"+text
                    +"|"+marker.getPosition().lat()
                    +","+marker.getPosition().lng()
                )
            }
        })

        direction_renders.forEach((render,n)=>{
            let {
                strokeWeight,
                strokeColor,
                strokeOpacity
            } = direction_stroke_options[n].polylineOptions

            let waypoints = []
            const result = render.getDirections()

            if ( result ) {
//                console.log(result.routes[0].legs[0])
                let polylines = []
                result.routes[0].legs[0].steps.forEach((step) => {
//                    console.log(step.polyline)
                    polylines.push(step.polyline.points);
                    step.path.forEach((point) => {
//                        waypoints.push(point.lat()+","+point.lng());
                        waypoints.push([point.lat(),point.lng()])
//                        polyline+=point;
                    });
                });
//                console.log(waypoints)
                rtnArray.push(polylines.map((polyline)=>{
                    return (
                        "path=weight:"+ strokeWeight +
                        "|color:"+ strokeColor.replace("#", "0x") + parseInt(Number(strokeOpacity) * 255).toString(16)+
    //                    "|"+waypoints.join("|")
                        "|enc:"+polyline
                    )                    
                }).join("&"))
/*
                rtnArray.push(
                    "path=weight:"+ strokeWeight +
                    "|color:"+ strokeColor.replace("#", "0x") + parseInt(Number(strokeOpacity) * 255).toString(16)+
//                    "|"+waypoints.join("|")
                    "|enc:"+polyline
                )
*/
            }
        })

        return (arrayflag)? rtnArray : "&" + rtnArray.join("&")
    }

    convert_object_polygon (index) {
        let {
            polygons,
            polygon_drawer_options: options
        } = this.state.map_data[index].objects

        let rtnArrayObject = []

        polygons.forEach((polygon, index)=>{
            let arrayCoords = []
            // 図形の緯度経度情報を取得
            polygon.getPath().forEach((latLng)=>{
                arrayCoords.push({
                    lat: latLng.lat(),
                    lng: latLng.lng()
                })
            })
            rtnArrayObject.push({
                polygon: {
                    color: polygon.strokeColor,
                    fillcolor: polygon.fillColor,
                    opacity: polygon.fillOpacity,
                    weight: polygon.strokeWeight,
                    points:arrayCoords
                }
            })
        })
        return rtnArrayObject
    }
    convert_uri_polygon (index, arrayflg = true) {
        let {
            polygons,
            polygon_drawer_options: options
        } = this.state.map_data[index].objects

        let rtnArray = []

        if (polygons.length == 0) return "" 

        polygons.forEach((polygon, index)=>{
            let arrayCoords = []
            let {
                strokeColor,
                fillColor,
                fillOpacity,
                strokeWeight,
            }=polygon
            // 図形の緯度経度情報を取得
            polygon.getPath().forEach((latLng)=>{
//                arrayCoords.push( latLng.lat() + "," + latLng.lng() )
                arrayCoords.push([latLng.lat(),latLng.lng()])
            })
            rtnArray.push(
//                "path=fillcolor:blue|weight:0|color:red|"
                "path=fillcolor:" + fillColor.replace("#", "0x") + parseInt(Number(fillOpacity) * 255).toString(16)
                +"|weight:" + strokeWeight
                +"|color:" + strokeColor.replace("#", "0x") +"00" + "|"
//                + arrayCoords.join("|")
                +"enc:"+encodeArrayPoints(arrayCoords)
            )
        })

//        console.log(rtnArray)
        return (arrayflg)? rtnArray : "&" + rtnArray.join("&")

    }
    convert_object_memo (index) {
        let {
            window,
            memo_marks,
        } = this.state.map_data[index].objects

        let rtnArrayObject = []

        window.forEach((infoWindow,index)=>{
            let marker = memo_marks[index]
            let color = marker.getIcon().fillColor
            let text = marker.getLabel().text

            rtnArrayObject.push({
                memo : {
                    marker : {
                        text : text,
                        color: color,
                        lat: marker.getPosition().lat(),
                        lng: marker.getPosition().lng(),
                    },
                    contents: infoWindow.getContent()
                }
            })
        })
        return rtnArrayObject;
    }
    convert_uri_memo (index, arrayflg = true) {
        let {
            memo_marks,
            window
        } = this.state.map_data[index].objects

        let rtnArray = []

        window.forEach((infoWindow,index)=>{
            let marker = memo_marks[index]
            let color = marker.getIcon().fillColor
            let text = marker.getLabel().text

            rtnArray.push(
                "markers=color:"+color.replace("#", "0x")
                +"|label:"+text
                +"|"+marker.getPosition().lat()
                +","+marker.getPosition().lng()
            )
        })
        return (arrayflg)? rtnArray : "&" + rtnArray.join("&")
    }

    parkingDetail (parkings, index) {
        return (<>
            {parkings.map(
                (parking, subIndex)=>{
                    let num = index * 3 + subIndex + 1;
                    return(<>
                        <div className="list-parking-detail__item">
                        <h4 className="title">
                            駐車場<span className="number">{num}</span>
                        </h4>
                        <div className="detail-info">
                            <Row>
                                <Col lg="6">
                                    <div className="detail-info__table">
                                        <div className="item item-parking">
                                            <div className="item__left">
                                                <span>駐車場名</span>
                                            </div>
                                            <div className="item__right">
                                                <span>{parking.data.parking_name}</span>
                                                <span>現場からの距離</span>
                                                <span>18分</span>
                                            </div>
                                        </div>

                                        <div className="item item-vehicle-size">
                                            <div className="item__left">
                                                <span>車両サイズ</span>
                                            </div>
                                            <div className="item__right text-center">
                                                <span>ワゴン：{parking.data.capacity_flag_car}台</span>
                                                <span>軽トラ：{parking.data.capacity_flag_light_truck}台</span>
                                                <span>2t：{parking.data.capacity_flag_truck}台</span>
                                                {/*<span>その他：{parking.capacity_flag_other}台</span>*/}
                                            </div>
                                        </div>
                                        {/*
                                        <div className="item item-daily-rate">
                                            <div className="item__left">
                                                <span>日割</span>
                                            </div>
                                            <div className="item__right">
                                                <span>日割開始月：×</span>
                                                <span>日割終了月：×</span>
                                                <span>一月単位の計算：×</span>
                                            </div>
                                        </div>
                                        */}
                                        <div className="item item-remarks">
                                            <div className="item__left">
                                                <span>特記事項</span>
                                            </div>

                                            <div className="item__right text-center">
                                                <span>現在 1 台分空有</span>
                                            </div>
                                        </div>

                                        <div className="item item-image">
                                            <div className="box-img text-center">
                                                <img src={parking.data.picture} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col lg="6">
                                    <div id={`DetailMap-${num}`} className="detail-info__map"/>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    </>)
                }
            )
        }
        </>);
    }
    staticmapUrl ( index, showKey=true ) {
        let baseUrl = (showKey)?"https://maps.googleapis.com/maps/api/staticmap?key=" + googleMapKey: "https://maps.googleapis.com/maps/api/staticmap?"
        baseUrl = baseUrl + this.convert_map_param( index, false )
        + this.convert_uri_marker( index, false )
        + this.convert_uri_direction( index, false )
        + this.convert_uri_polygon( index, false )
        + this.convert_uri_memo( index, false )
        
//        console.log(baseUrl)

        return baseUrl
    }
    copyToClipboard() {
        let element = document.getElementById("googleMapsUrl")
        navigator.clipboard.writeText(element.value).then(()=>{
//            console.log("copy success");
            window.alert("コピーしました。")
        },(err)=>{
//            console.log("copy failed");
        })
    }
    onClickMapHandle (e) {
        let index = this.state.view_index;
        let {
            objects,
            edit_mode
        } = this.state.map_data[index]
        // 緯度経度情報
        const coord = { lat: e.latLng.lat(), lng: e.latLng.lng() }
//        console.log(coord, edit_mode);

        switch ( edit_mode ) {
            case MODE_GRAB:{

            }break;
            case MODE_MARKER:{

            }break;
            case MODE_POLYGON:{
                this.addPolygon(e,index)
            }break;
        }
    }
    onchangeMapIndex (index) {
        Request.setProgress(20,"地図読み込み中")
        let {map_data, googleMaps} = this.state
        let hideMapData = this.state.map_data[this.state.view_index]

        let zoom = googleMaps.map.getZoom()
        let lat = googleMaps.map.getCenter().lat()
        let lng = googleMaps.map.getCenter().lng()
        hideMapData.map_settings = {
            ...hideMapData.map_settings,
            center: {
                lat : lat,
                lng : lng
            },
            zoom: zoom
        }
        map_data[this.state.view_index] = hideMapData;

        let {
            window,
            window_instance,
            markers,
            distinates_markers,
            direction_renders,
            direction_services,
            direction_waypoints,
            polygons,
            memo_marks
        } = hideMapData.objects
        markers.map((m)=>m.setMap(null))
        distinates_markers.map((dm)=>dm.setMap(null))
        direction_renders.map((dr)=>dr.setMap(null))
        polygons.map((p)=>p.setMap(null))
        memo_marks.map((mm)=>mm.setMap(null))
        window.map((w)=>w.close())

        this.setState({
            map_data: map_data
        },()=>{
            console.log(this.state.view_index,map_data[this.state.view_index])
            let data = this.state.map_data[index]

            if ( data.isload === false ) {
                this.loadMapView(index);
            }
            else {
                let {map} = this.state.googleMaps;
    
                let {
                    window,
                    window_instance,
                    distinates_markers, // 目的地アイコン
                    direction_renders,
                    direction_services,
                    direction_waypoints,
                    markers,
                    polygons,
                    memo_marks
                } = data.objects
                markers.map((m)=>m.setMap(map))
                distinates_markers.map((dm)=>dm.setMap(map))
                direction_renders.map((dr)=>dr.setMap(map))
                polygons.map((p)=>p.setMap(map))
                memo_marks.map((mm, n)=>{
                    mm.setMap(map)
                    window[n].open({
                        anchor: mm, map
                    })
                })
                map.setOptions(data.map_settings)
                console.log(index,data)
            }

            this.setState({
                view_index:index,
            })
        })
        setTimeout(()=>{Request.setProgress(80,"地図読み込み中")},500)
        setTimeout(()=>{Request.setProgress(0,"地図読み込み中")},1000)
    }
    render () {
        let {map_data, request_data, map_settings} = this.state
        let param = map_data[this.state.view_index]
//        console.log((this.state.map_data.filter((mapData)=>mapData.isload===false).length>0))
        let baseUrl = "https://www.google.com/maps/dir/?api=1&travelmode=walking" // QRコード用URL生成用パラメータ
//        let {map} = this.state.googleMaps
//        let center = map?{lat: map.getCenter().lat(), lng: map.getCenter().lng()} : undefined
        let {center} = map_settings
        return (<>
            <div className="content route-map">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h3">経路図編集</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row className="tab-menu">
                                {map_data && (
                                    map_data.map((objects, index)=>{
                                        return(<div className={(this.state.view_index==index)?"on":""} onClick={()=>{this.onchangeMapIndex(index)}}>
                                            {index+1}
                                        </div>)
                                    })
                                )}
                                </Row>
                                <div className="info mb-4">
                                    <div className="info__item">
                                        <span>工事番号</span>
                                        <span>{request_data.project_natural_id}</span>
                                    </div>
                                    <div className="info__item">
                                        <span>現場名</span>
                                        <span>{request_data.site_name}</span>
                                    </div>
                                </div>
                                <div className="parking-route">
                                    <div className="parking-route__info">
                                        <Row>
                                            <Col style={{width:(baseMapSize.width + 10)+"px"}}>
                                                <div id="MapDiv" className="map-polygon" style={{width:baseMapSize.width+"px",height:baseMapSize.height+"px"}}/>
                                            </Col>
                                            <Col>
                                                {this.controller(param,this.state.view_index)}
                                                <div>
                                                    <table className="parkingDetailInfo">
                                                    {param.coordinates.distinates.map((dist, n)=>{
                                                        let num = this.state.view_index * 3 + n;
                                                        let dm = param.objects.distinates_markers[n]
                                                        let mapUrl = ""
                                                        if (dm) {
                                                            let coord = {lat:dm.getPosition().lat(), lng:dm.getPosition().lng()}
                                                            mapUrl = baseUrl+`&origin=${center.lat},${center.lng}&destination=${coord.lat},${coord.lng}`
                                                        }
                                                        return(<tr>
                                                            <th>{aryAlphabet[num]}</th>
                                                            <td>
                                                                {dist.data.parking_name}&nbsp;
                                                                {center && (<>
                                                                    <div class="google-map-url">{mapUrl}</div>&nbsp;
                                                                    <CopyToClipboard text={mapUrl} onCopy={()=>{window.alert("コピーしました。")}}>
                                                                        <button>コピー</button>
                                                                    </CopyToClipboard>
                                                                </>)}
                                                            </td>
                                                        </tr>)
                                                    })}
                                                    </table>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div style={{textAlign:"center"}}>
                                        <Button color="primary" onClick={()=>this.save()}>
                                            {(this.state.map_data.filter((mapData)=>mapData.isload===false).length>0)? "次へ":"保存"}
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal isOpen={this.state.modal_monochrome_map} className="modalMonochromeMap">
                <ModalBody>
                    <img style={{width:baseMapSize.width+"px",height:baseMapSize.height+"px"}} src={this.staticmapUrl(this.state.modal_map_index)} alt="googlestaticmap" />
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({modal_monochrome_map:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.confirm_map_url}  className="">
                <ModalBody>
                    <textarea id="googleMapsUrl" name="googleMapsUrl" rows="10" cols="70" readonly value={this.staticmapUrl(this.state.view_index)}>
                        {this.staticmapUrl(this.state.view_index, false)}
                    </textarea>
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.copyToClipboard()}}>URLコピー</Button>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({confirm_map_url:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
        </>);
    }

    _render () {
        const {
            request_data,
            parkings,
            full_parkings,
            map_data
        } = this.state
//        console.log(this.state);

        return (<>
            <div className="content route-map">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h3">経路図編集</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row className="tab-menu">
{/*
                                {map_data && (
                                    map_data.map((objects, index)=>{
                                        return(<div className={(this.state.view_index==index)?"on":""} onClick={()=>{this.setState({view_index:index})}}>
                                            {index+1}
                                        </div>)
                                    })
                                )}
*/}
                                </Row>
                                {map_data && (
                                    map_data.map((objects, index)=>{
                                    return (<>
                                        <div className={(this.state.view_index==index)?"on":""} onClick={()=>{this.setState({view_index:index})}}>
                                            {index+1}
                                        </div>
                                        <div className="info mb-4" style={{display:(this.state.view_index == index)? "":"none"}}>
                                            <div className="info__item">
                                                <span>工事番号</span>
                                                <span>{request_data.project_natural_id}</span>
                                            </div>
                                            <div className="info__item">
                                                <span>現場名</span>
                                                <span>{request_data.site_name}</span>
                                            </div>
                                        </div>
                                        <div className="parking-route" style={{display:(this.state.view_index == index)? "":"none"}}>
                                            <div className="parking-route__info">
                                                <Row>
                                                    <Col lg="7">
                                                        <div id={"MapDiv-"+ ( index + 1 )} className="map-polygon" />
                                                    </Col>
                                                    <Col lg="5">
                                                        {this.controller(objects,index)}
                                                        <div>
                                                            <table className="parkingDetailInfo">
                                                            {objects.coordinates.distinates.map((dist, n)=>{
                                                                let num = index * 3 + n;
                                                                return(<tr>
                                                                    <th>{aryAlphabet[num]}</th>
                                                                    <td>{dist.data.parking_name}</td>
                                                                </tr>)
                                                            })}
                                                            </table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div style={{textAlign:"center"}}>
                                                <Button color="primary" onClick={()=>this.save()}>保存</Button>
                                            </div>
                                            {/* 駐車場詳細 */}
{/*
                                            <div className="list-parking-detail mt-5">
                                                {this.parkingDetail(objects.coordinates.distinates ,index)}
                                            </div>
*/}
                                        </div>
                                    </>)}
                                    )
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal isOpen={this.state.modal_monochrome_map} className="modalMonochromeMap">
                <ModalBody>
                    <img style={{width:baseMapSize.width+"px",height:baseMapSize.height+"px"}} src={this.staticmapUrl(this.state.modal_map_index)} alt="googlestaticmap" />
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({modal_monochrome_map:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.confirm_map_url}  className="">
                <ModalBody>
                    <textarea id="googleMapsUrl" name="googleMapsUrl" rows="10" cols="70" readonly value={this.staticmapUrl(this.state.view_index, false)}>
                        {this.staticmapUrl(this.state.view_index, false)}
                    </textarea>
                </ModalBody>
                <ModalFooter>
                    <Button style={{margin:"auto"}} onClick={()=>{this.copyToClipboard()}}>URLコピー</Button>
                    <Button style={{margin:"auto"}} onClick={()=>{this.setState({confirm_map_url:false})}}>閉じる</Button>
                </ModalFooter>
            </Modal>
        </>);
    }
}
